import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e19139b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-div" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column is-one-third-desktop is-offset-one-third-desktop" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://i.imgur.com/uA3fRLZ.png",
    class: "image",
    alt: "logo"
  })
], -1))
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "control" }
const _hoisted_12 = { class: "help" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "control" }
const _hoisted_16 = { class: "help" }
const _hoisted_17 = {
  type: "submit",
  class: "mt-5 button is-primary is-fullwidth"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  class: "is-flex is-flex-direction-column is-align-items-center"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://i.imgur.com/uA3fRLZ.png",
    class: "image",
    alt: "logo"
  })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spinner fa-spin has-text-grey-light fa-6x" })
], -1))
const _hoisted_22 = { class: "mt-4 has-text-centered" }
const _hoisted_23 = { class: "is-size-5" }
const _hoisted_24 = {
  key: 1,
  class: "is-flex is-flex-direction-column is-align-items-center"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://i.imgur.com/uA3fRLZ.png",
    class: "image",
    alt: "logo"
  })
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-times-circle has-text-danger fa-6x" })
], -1))
const _hoisted_27 = { class: "mt-4 has-text-centered" }
const _hoisted_28 = { class: "is-size-5" }
const _hoisted_29 = {
  key: 2,
  class: "is-flex is-flex-direction-column is-align-items-center"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://i.imgur.com/uA3fRLZ.png",
    class: "image",
    alt: "logo"
  })
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-check has-text-success fa-6x" })
], -1))
const _hoisted_32 = { class: "mt- has-text-centered" }
const _hoisted_33 = { class: "is-size-5" }
const _hoisted_34 = { class: "has-text-grey" }
const _hoisted_35 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.isEmailFilled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("form", {
                      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmEmail && _ctx.confirmEmail(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('message.scheduleMeeting')), 1),
                        _createElementVNode("div", _hoisted_11, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.datetime) = $event)),
                            class: "input",
                            type: "datetime-local",
                            id: "schedule",
                            required: ""
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.datetime,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('message.insertMeetingDateAndTime')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('message.yourEmail')), 1),
                        _createElementVNode("div", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                            class: "input",
                            type: "email",
                            placeholder: "vet@doctor.com",
                            required: ""
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.email,
                              void 0,
                              {
                                trim: true,
                                lazy: true
                              }
                            ]
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('message.insertRegisteredEmail')), 1)
                      ]),
                      _createElementVNode("button", _hoisted_17, _toDisplayString(_ctx.$t('message.confirmMeeting')), 1)
                    ], 32)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_ctx.isConfirming)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _hoisted_20,
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('message.confirmingMeeting')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isConfirming && !_ctx.isConfirmed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _hoisted_25,
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t('message.cantActivateMeeting')), 1),
                        _createElementVNode("button", {
                          class: "button is-warning mt-5",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
                        }, _toDisplayString(_ctx.$t('message.checkEmail')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isConfirmed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _hoisted_30,
                      _hoisted_31,
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t('message.meetingConfirmed')), 1),
                        _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('message.emailSentWithAccessDetails')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("p", null, [
                          _createVNode(_component_router_link, {
                            to: _ctx.meetingURL,
                            class: "button is-primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('message.accessMeeting')), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ])
    ])
  ]))
}